import { isBookmarksAttribute, isHomePageAttribute } from '../../../types/navPersona';
import { RELEVANCY_DATA_SOURCES } from '../../../types/relevancyData';
import { getPageNameBasedRelevancyData } from './pageBasedRecUtils';
import { combineRelevancyData } from '../relevancyScoreUtils';
export const getHomepagePageName = navPersona => {
  const homepageAttribute = navPersona.navPersonaPortalUserAttributes.find(attribute => isHomePageAttribute(attribute));
  return homepageAttribute === null || homepageAttribute === void 0 ? void 0 : homepageAttribute.personaAttributeValue;
};
export const getBookmarkPageNames = navPersona => {
  const bookmarksAttribute = navPersona.navPersonaPortalUserAttributes.find(attribute => isBookmarksAttribute(attribute));
  const bookmarksValue = bookmarksAttribute === null || bookmarksAttribute === void 0 ? void 0 : bookmarksAttribute.personaAttributeValue;
  if (!bookmarksValue) {
    return [];
  }
  try {
    const {
      ids: pageIds
    } = JSON.parse(bookmarksValue);
    return pageIds || [];
  } catch (error) {
    return [];
  }
};
export const getHomepageRelevancyData = navPersona => {
  const homepagePageName = getHomepagePageName(navPersona);
  const relevancyData = homepagePageName && getPageNameBasedRelevancyData(homepagePageName);
  return relevancyData ? Object.assign({
    dataSource: RELEVANCY_DATA_SOURCES.HOME_PAGE
  }, relevancyData) : null;
};
export const getBookmarksRelevancyData = navPersona => {
  const bookmarkPageNames = getBookmarkPageNames(navPersona);
  const bookmarksRelevancyData = bookmarkPageNames.reduce((memo, pageName) => {
    const pageRelevancyData = getPageNameBasedRelevancyData(pageName);
    if (pageRelevancyData) {
      memo.push(pageRelevancyData);
    }
    return memo;
  }, []);
  if (bookmarksRelevancyData.length === 0) {
    return null;
  }
  const combinedData = combineRelevancyData(bookmarksRelevancyData);
  return Object.assign({
    dataSource: RELEVANCY_DATA_SOURCES.BOOKMARKS
  }, combinedData);
};